interface SuccessMessage {
  jwt: string
  error: null
}

interface ErrorMessage {
  jwt: null
  error: string
}

/**
 * Send a message to the opener window to let them know that login/register is done.
 */
export function notifyOpenerOnSuccess(jwt: string) {
  if (!window.opener?.postMessage) return
  window.opener.postMessage({ jwt, error: null } satisfies SuccessMessage, '*')
}

/**
 * Send a message to the opener window to let them know of any error.
 */
export function notifyOpenerOnError(error: string) {
  if (!window.opener?.postMessage) return
  window.opener.postMessage({ jwt: null, error } satisfies ErrorMessage, '*')
}
